import type { Ref } from 'vue'
import { computed } from 'vue'
import useSWRV from 'swrv'

import { captureException as newrelicCaptureException } from '@/newrelic'

import type { Match } from '@/types/app'
import { isClientError, isNotFoundError } from '@/libs/utilities/CustomErrors'
import { FetchKarteOnUseKarteDocument } from './useKarte.generated'
import type { FetchKarteOnUseKarteQuery } from './useKarte.generated'
import { useApolloClient } from '@vue/apollo-composable'

export const useKarte = (match: Ref<Maybe<Match>>) => {
  const userId = computed(() => match.value?.user.id)

  const apollo = useApolloClient()

  const fetcher = async () => {
    if (userId.value == undefined) {
      return null
    }

    try {
      const { data: result } =
        await apollo.client.query<FetchKarteOnUseKarteQuery>({
          query: FetchKarteOnUseKarteDocument,
          variables: {
            id: userId.value.toString(),
          },
        })
      return result.user.karte ?? null
    } catch (e) {
      console.error(e)
      if (!isClientError(e) || isNotFoundError(e)) {
        newrelicCaptureException(e)
      }

      return null
    }
  }

  const { data, isValidating: loading } = useSWRV(
    () =>
      userId.value !== undefined ? `getKarteByUserID/${userId.value}` : null,
    fetcher
  )

  const karte = computed(() => data.value ?? undefined)

  return {
    karte,
    loading,
  }
}
